import { Action } from '@/_core/fluxstore/types';
import { ProductsState } from '../types';
import { useProductsStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeProductSlug as ChangeProductSlugCommand, ChangeProductSlugResult } from '@/api/manageProducts/commands';
import * as manageStoreModule from '../../ManageProducts';

const { registerMiddleware, registerReducer } = useProductsStore();

export class ChangeProductSlug extends Action<ProductsState> {
    public static ACTION_TYPE = 'ChangeProductSlug';
    public _res: ChangeProductSlugResult;

    public constructor(public id: string, public slug: string) {
        super(ChangeProductSlug.ACTION_TYPE);
    }
}

const middleware = async (state: ProductsState, action: ChangeProductSlug): Promise<boolean> => {
    return useSendCommand(action, {
        createCommand: () => new ChangeProductSlugCommand(action.id, action.slug),
        onSuccess: (res) => {
            action._res = res;
        },
    });
};

const initAppDataMiddleware = async (state: ProductsState, action: ChangeProductSlug): Promise<boolean> => {
    if (action._res.IsSuccess && initAppData.isInWsContext) {
        const product = initAppData.currentWs.products.find((x) => x.id === action.id);
        product.slug = action._res.Slug;
    }

    return true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const manageProductsMiddleware = async (state: ProductsState, action: ChangeProductSlug): Promise<boolean> => {
    const otherStore = manageStoreModule.useManageProductsStore();
    if (otherStore.state.isInitialized) {
        await otherStore.dispatch(new manageStoreModule.InitManageProducts());
    }

    return true;
};

const reducer = (state: ProductsState, action: ChangeProductSlug): void => {
    const product = state.products.find((x) => x.id == action.id);
    product.slug = action._res.Slug;
};

//@ts-ignore
registerMiddleware(ChangeProductSlug.ACTION_TYPE, middleware);

//@ts-ignore
registerMiddleware(ChangeProductSlug.ACTION_TYPE, initAppDataMiddleware);

//@ts-ignore
registerMiddleware(ChangeProductSlug.ACTION_TYPE, manageProductsMiddleware);

//@ts-ignore
registerReducer(ChangeProductSlug.ACTION_TYPE, reducer);
